function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useState, useRef } from 'react';
import { Col, Row, Card, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Button, SaveButton } from '../../util/buttons';
import ImmutableUnderReviewFormControl from '../../util/reviewEditControls/ImmutableUnderReviewFormControl';
import UnsavedChangesPrompt from '../../components/UnsavedChangesPrompt';
const renderSaveButton = (type, buttonProps, submitLabel) => {
  if (type === 'save') {
    return /*#__PURE__*/React.createElement(SaveButton, buttonProps);
  } else {
    return /*#__PURE__*/React.createElement(Button, buttonProps, submitLabel);
  }
};
const TechnicalUploadsForm = _ref => {
  let {
    type,
    isImmutableUnderReview = false,
    handleSubmit,
    loading,
    isSignedOff,
    showDocumentType = true,
    showAddCommentTextInput = true,
    setParentHasUnsavedChanges = () => {},
    addDocumentClass = {}
  } = _ref;
  const hiddenFileInput = useRef(null);
  const {
    t
  } = useTranslation();
  const [selectedFile, setSelectedFile] = useState(null);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [technicalUpload, setTechnicalUpload] = useState({
    document_type: 'tax_computations'
  });
  const handleChange = e => {
    setHasUnsavedChanges(true);
    setParentHasUnsavedChanges(true);
    setTechnicalUpload(_objectSpread(_objectSpread({}, technicalUpload), {}, {
      comments: e.target.value
    }));
  };
  const onDocumentTypeChange = e => {
    setHasUnsavedChanges(true);
    setParentHasUnsavedChanges(true);
    setTechnicalUpload(_objectSpread(_objectSpread({}, technicalUpload), {}, {
      document_type: e.target.value
    }));
  };
  const handleClick = () => {
    hiddenFileInput.current.click();
  };
  const addFile = event => {
    setHasUnsavedChanges(true);
    if (setParentHasUnsavedChanges) {
      setParentHasUnsavedChanges(true);
    }
    setSelectedFile(event.target.files[0]);
  };
  const submit = () => {
    handleSubmit(technicalUpload, selectedFile);
    setHasUnsavedChanges(false);
    setSelectedFile(null);
    setParentHasUnsavedChanges(false);
    setTechnicalUpload({
      document_type: 'tax_computations'
    });
    hiddenFileInput.current.value = '';
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(UnsavedChangesPrompt, {
    hasUnsavedChanges: hasUnsavedChanges
  }), /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 2,
    style: addDocumentClass
  }, /*#__PURE__*/React.createElement(Button, {
    isImmutableUnderReview: isImmutableUnderReview,
    variant: "primary",
    onClick: handleClick,
    disabled: loading || isSignedOff
  }, t('add_document')), /*#__PURE__*/React.createElement("input", {
    style: {
      display: 'none'
    },
    type: "file",
    "data-testid": "technicalDocumentUpload",
    ref: hiddenFileInput,
    onChange: e => addFile(e)
  }), /*#__PURE__*/React.createElement("p", null, selectedFile && selectedFile.name)), showAddCommentTextInput && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 2
  }, t('please_add_additional_comments')), /*#__PURE__*/React.createElement(Col, {
    md: 2
  }, /*#__PURE__*/React.createElement(ImmutableUnderReviewFormControl, {
    onChange: handleChange,
    name: "comments",
    value: technicalUpload.comments || '',
    size: "md",
    type: "text"
  }))), showDocumentType && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 2
  }, t('please_select_document_type')), /*#__PURE__*/React.createElement(Col, {
    md: 2
  }, /*#__PURE__*/React.createElement(ImmutableUnderReviewFormControl, {
    as: "select",
    value: technicalUpload.document_type,
    onChange: e => onDocumentTypeChange(e)
  }, process.env.PUBLIC_URL !== '/us' && /*#__PURE__*/React.createElement("option", {
    key: 'tax_computations',
    value: 'tax_computations'
  }, t('tax_computations')), /*#__PURE__*/React.createElement("option", {
    key: 'accounts',
    value: 'accounts'
  }, t('accounts')), /*#__PURE__*/React.createElement("option", {
    key: 'other',
    value: 'other'
  }, t('other'))))), /*#__PURE__*/React.createElement(Col, {
    md: {
      span: 1,
      offset: 1
    }
  }, renderSaveButton(window.MARKET_CONSTANTS.TECHNICAL_UPLOAD_SUBMIT_BUTTON_TYPE, {
    isImmutableUnderReview,
    loading,
    variant: 'primary',
    onClick: submit,
    disabled: isSignedOff
  }, t('submit')))))));
};
export default TechnicalUploadsForm;